<template>
  <component
    ref="editReservation"
    :is="currentComponent"
    :key="purchaseType"
  ></component>
</template>
<script>
// Importamos los dos componentes que serán renderizados condicionalmente
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["purchaseType"]),
    currentComponent() {
      return this.purchaseType === "reservation"
        ? () => import("@/modules/reservations/pages/EditReservations")
        : () => import("@/modules/reservations/pages/EditReservationsVentrata");
    }
  },
  beforeRouteLeave(to, from, next) {
    const child = this.$refs["editReservation"];
    if (child && typeof child.detectChanges === "function") {
      child.detectChanges(to, from, next);
    } else {
      next();
    }
  }
};
</script>
